import React from 'react';
import { Card, CardImg, CardText, CardBlock,
  CardTitle } from 'reactstrap';

class ProductCard extends React.PureComponent {
  render() {
    const { meals, onImageClick } = this.props;
    const imagePath = process.env.PUBLIC_URL + "/images/" + meals.picture;
    return (
      <div className=" py-3 col-xl-6 col-md-12 float-left">
        <Card className={'myCard'}>
          <div className='row'>
            <div className="col-lg-4 col-md-4 col-sm-4  col-xs-12">
              <button
                className="product-image-button"
                type="button"
                onClick={() => onImageClick(meals)}
                aria-label={`Open details for ${meals.name}`}
              >
                <picture>
                  <source srcSet={`${imagePath}.webp`} type="image/webp" />
                  <CardImg
                    top
                    width="100%"
                    src={`${imagePath}.png`}
                    className={'specialCard float-left'}
                    alt={meals.name}
                    loading="lazy"
                    decoding="async"
                  />
                </picture>
              </button>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12 cardText">
            <CardBlock className={'px-3'}>
              <CardTitle>{meals.name}</CardTitle>
              {/*<CardSubtitle className={'extra'}>{meals.contain.join(', ')}</CardSubtitle>*/}
              <CardText>{meals.body}</CardText>
              <CardTitle className={"maR price"}>{meals.price+",-"}</CardTitle>
            </CardBlock>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default ProductCard;
